import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '@/lib/api';
import { contactValue } from '@/lib/public-intake-guards.mjs';

const ORIGIN = 'https://www.cainversionesservicios.com';
const BRAND = 'C&A Transporte & Rescate';

// Service-area business: a configured administrative address is not a public storefront.
export function businessSchema(config) {
  let contact = null;
  try { contact = contactValue(config); } catch { /* Keep the confirmed brand fallback. */ }
  const base = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${ORIGIN}/#organization`,
    name: contact?.commercial_name || BRAND,
    url: `${ORIGIN}/`,
    areaServed: ['San Cristóbal', 'Santo Domingo'].map(name => ({ '@type': 'Place', name })),
    hasOfferCatalog: {
      '@type': 'OfferCatalog', name: 'Servicios de C&A',
      itemListElement: ['Grúa plataforma', 'Asistencia vial', 'Traslado de vehículos'].map(name => ({
        '@type': 'Offer', itemOffered: { '@type': 'Service', name },
      })),
    },
  };
  if (contact?.phone) base.telephone = contact.phone;
  return base;
}

export default function BusinessStructuredData() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname !== '/' && pathname !== '/website' && pathname !== '/contact') return;
    const script = document.createElement('script');
    script.id = 'ca-business-schema';
    script.type = 'application/ld+json';
    document.head.appendChild(script);
    const render = config => { script.textContent = JSON.stringify(businessSchema(config)); };
    render(null);
    const controller = new AbortController();
    api.get('/config/company/public', { signal: controller.signal, timeout: 15000 })
      .then(({ data }) => render(data)).catch(() => { /* Fallback Organization stays visible. */ });
    return () => { controller.abort(); script.remove(); };
  }, [pathname]);
  return null;
}

